export default {
  title: {
    management: 'Clinic Management',
    clinic: 'Clinic',
    managePatient: 'Manage Patients',
    edit: 'Edit Clinic Information',
    user: {
      edit: 'Edit User Information'
    }
  },
  headers: {

  },
  label: {
    name: 'Room Name',
    clinicRoom: 'Clinic Room',
    clinicId: 'Clinic ID',
    clinicName: 'Clinic Name',
    clinicNameEn: 'Clinic Name (EN)',
    bed: 'Bed',
    timer: 'Timer',
    noneTimer: 'No Timer',
    type: 'Room Type',
    info: 'Clinic Information',
    bedQty: 'Number of Beds',
    person: 'Authorized Users',
    license: 'License Number',
    medicalLicenseNumber: 'Medical Practice License Number',
    vat: 'Value Added Tax',
    vatType: 'VAT Type',
    vatPlusProduct: 'VAT included in product price',
    vatMinusProduct: 'VAT calculated separately from product price',
    storeData: 'Store Data',
    vatValue: 'VAT Amount',
    downloadList: 'Download List',
    downloading: 'Downloading Data',
    seeNews: 'View News',
    news: 'News',
    downloadDoc: 'Downloaded Documents',
    form: 'Form',
    newsTitle: 'News Title',
    recipients: 'Number of Recipients (people)',
    newsChanal: 'Delivery Channel',
    newsDetail: 'News Details',
    sendTime: 'Send Time',
    target: 'Target Group',
    oneByOne: 'Specify Individually',
    text: 'Message',
    newsSave: 'Save and Send Message',
    theme: 'Theme Color',
    color: 'Color',
    menuColor: 'Menu Color',
    mainColor: 'Main Color',
    subColor: 'Sub Color',
    user: 'User',
    role: 'Role',
    roles: {
      owner: 'Owner',
      admin: 'Admin',
      doctor: 'Doctor',
      cashier: 'Cashier',
      manager: 'Manager',
      stockManager: 'Stock Manager',
      serviceStaff: 'Service Staff',
      reception: 'Reception'
    },
    link: 'User Link',
    copy: 'Copied!',
    sendEmail: 'Send Invitation Email',
    waitConfirmation: 'Waiting for Confirmation',
    confirmed: 'Confirmed'
  },
  placeholder: {
    info: 'Enter Clinic Information',
    name: 'Enter Room Name',
    clinicName: 'Enter Clinic Name',
    clinicNameEn: 'Clinic Name (EN)',
    bedQty: 'Enter Number of Beds',
    color: 'Select Room Color',
    selectColor: 'Select Desired Room Color',
    border: 'Select Border Color',
    selectBrder: 'Select Desired Border Color',
    license: 'Enter License Number',
    medicalLicenseNumber: 'Medical Practice License Number',
    medicalPracticeLocation: 'Medical Practice Location - Private Chinese Medical Clinic Physical Examined',
    medicalPracticeLocationsec1: 'Medical Practice Location',
    vat: 'Enter Value Added Tax',
    downloadDoc: 'Download Documents',
    newsChanal: 'Select Delivery Channel',
    newsTitle: 'Enter Title',
    title: 'Title',
    searchEmailUser: 'Search by Email or Username',
    role: 'Enter Role'
  },
  toolTip: {

  },
  modal: {
    create: {
      success: 'Clinic room created successfully!',
      news: {
        title: 'Create News',
        success: 'News created successfully'
      },
      user: {
        title: '',
        subTitle: '',
        success: 'User data created successfully!'
      }
    },
    edit: {
      success: 'Clinic room updated successfully!',
      news: {
        title: 'Edit News Information',
        success: 'News information updated successfully!'
      },
      user: {
        title: 'Confirm Staff Deletion',
        subTitle: 'You are about to delete a staff member from this clinic. Do you want to continue?',
        success: 'User information updated successfully!'
      }
    },
    delete: {
      title: 'Confirm Room Deletion',
      subtitle1: 'You are deleting the room',
      subtitle2: 'Do you want to continue?',
      news: {
        title: 'Confirm News Deletion',
        subTitle: 'You are deleting news. Do you want to continue?',
        success: 'News deleted successfully'
      },
      user: {
        title: 'Confirm Staff Deletion',
        subTitle: 'You are deleting a staff member from this clinic. Do you want to continue?'
      }
    }
  }
}
